import currenciesService from '../currenciesService';
import events from '../events';
import formatPrice from '../utils/formatPrice';
export function currencySwitcher(price = 0) {
    return {
        foreignPriceText: '',
        price: price,
        isNok: true,
        currencySwitcherInit() {
            this.applyCurrencyExchange(currenciesService.getRate());
            events.onCurrencyChanged.subscribe(currency => {
                this.applyCurrencyExchange(currency);
            });
        },
        refreshForeignPriceText(total) {
            this.price = total;
            const localStorageCurrency = currenciesService.getRate();
            localStorageCurrency && this.applyCurrencyExchange(localStorageCurrency);
        },
        applyCurrencyExchange(currency) {
            if (!currency)
                return;
            const foreignPrice = this.price * currency.rate;
            this.isNok = currency.currency == 'NOK';
            this.foreignPriceText = currency.rate !== 1 ? `~ ${formatPrice(foreignPrice, currency.currency)}` : '';
        },
    };
}
